// src/contexts/produtos/ProdutoFornecContext.js
// contexts/produtos/ProdutoFornecContext.js
import React, { createContext, useContext, useRef, useState } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { buscarFornecedoresPorProduto } from '../../services/produtos/ProdutoFornecService';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const ProdutoFornecContext = createContext();

export const useProdutoFornec = () => useContext(ProdutoFornecContext);

export const ProdutoFornecProvider = ({ children }) => {
    const [produtoFornecs, setProdutoFornecs] = useState([]);
    const [produtoFornecSel, setProdutoFornecSel] = useState();
    const consultaRef = useRef({ produtoId: 0 });
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    // 🔹 Busca todos os fornecedores de um produto específico
    const fetchProdutoFornecs = async (produtoId) => {
        const consulta = { produtoId: Number(produtoId) || 0 };
        consultaRef.current = consulta;
        setProdutoFornecs([]);
        if (!consulta.produtoId) return;

        try {
            const result = await buscarFornecedoresPorProduto(produtoId);
            if (consultaRef.current === consulta) setProdutoFornecs(result || []);
        } catch (error) {
            if (consultaRef.current !== consulta) return;
            console.error("Erro ao buscar fornecedores do produto:", error);
            showMessage('Erro ao buscar fornecedores do produto!\n' + error, 'danger');
        }
    };

    // 🔹 Busca o ID do produto pelo fornecedor e código do fornecedor
    const buscaIdProduto = async (fornecedorId, cProdFornec) => {
        return fetchData(
            `/ProdutoFornec/BuscaIdProduto?fornecedorId=${fornecedorId}&cProdFornec=${encodeURIComponent(cProdFornec)}`
        );
    };

    const resolverCodigos = async (fornecedorId, codigos) => {
        return postData('/ProdutoFornec/ResolverCodigos', { fornecedorId, codigos });
    };

    const resolverConflito = async (vinculo) => {
        const result = await putData('/ProdutoFornec/ResolverConflito', vinculo);
        setProdutoFornecs((atuais) => [
            ...atuais.filter((item) => !(
                item.fornecedorId === result.fornecedorId
                && item.cProdFornec === result.cProdFornec
            )),
            result,
        ]);
        setProdutoFornecSel(result);
        showAlert('Conflito de vínculo resolvido com sucesso!');
        return result;
    };


    // 🔹 Adiciona novo fornecedor ao produto
    const addProdutoFornec = async (produtoFornec) => {
        try {
            const result = await postData('/ProdutoFornec', produtoFornec);
            if (consultaRef.current.produtoId === Number(produtoFornec.produtoId)) {
                setProdutoFornecs((atuais) => atuais.some((item) => item.id === result.id)
                    ? atuais.map((item) => item.id === result.id ? result : item)
                    : [...atuais, result]);
            }
            setProdutoFornecSel(result);
            showAlert('Fornecedor vinculado ao produto com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao adicionar produto/fornecedor:", error);
            showMessage(error?.message || 'Erro ao adicionar produto/fornecedor!', 'danger');
            throw error;
        }
    };

    // 🔹 Atualiza fornecedor vinculado ao produto
    const updateProdutoFornec = async (produtoFornec) => {
        try {
            const result = await putData('/ProdutoFornec', produtoFornec);
            setProdutoFornecs((atuais) => atuais.map(p => p.id === result.id ? result : p));
            showAlert('Fornecedor vinculado atualizado com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao atualizar produto/fornecedor:", error);
            showMessage('Erro ao atualizar produto/fornecedor!\n' + error, 'danger');
            throw error;
        }
    };

    // 🔹 Exclui fornecedor do produto
    const deleteProdutoFornec = async (id) => {
        try {
            await deleteData('/ProdutoFornec', { produtoFornecId: id });
            setProdutoFornecs((atuais) => atuais.filter(p => p.id !== id));
            showAlert('Fornecedor desvinculado com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir produto/fornecedor:", error);
            showMessage('Erro ao excluir produto/fornecedor!\n' + error, 'danger');
            throw error;
        }
    };

    return (
        <ProdutoFornecContext.Provider
            value={{
                produtoFornecs,
                fetchProdutoFornecs,
                buscaIdProduto,
                resolverCodigos,
                resolverConflito,
                produtoFornecSel,
                addProdutoFornec,
                updateProdutoFornec,
                deleteProdutoFornec,
            }}
        >
            {children}
        </ProdutoFornecContext.Provider>
    );
};
